import api from 'Application/api/api';

const getLibraryInstructionsCount = (cancelToken = null) =>
    api.get('/education/library-instructions/count', {
        cancelToken,
    });

export default getLibraryInstructionsCount;
